import React from "react";
import PropTypes from "prop-types";
import { Form, Checkbox, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";

/**
 * Componente TAIFields
 * Campos adicionales que se muestran cuando una autorización es TAI.
 * Muestra el checkbox de "Con Acompañante" cuando:
 * - El tipo de traslado es Intermunicipal
 * - O hay algún CUPS Intermunicipal seleccionado (cuando hay múltiples CUPS de diferentes tipos)
 */
const TAIFields = ({
  tipoTraslado,
  conAcompanante = false,
  onConAcompananteChange,
  disabled = false,
  tieneIntermunicipal = false,
}) => {
  // Mostrar si el tipo de traslado es Intermunicipal O si alguno de los CUPS seleccionados es Intermunicipal
  const esIntermunicipal = tipoTraslado?.toLowerCase() === "intermunicipal";
  const mostrarCheckbox = esIntermunicipal || tieneIntermunicipal;

  if (!mostrarCheckbox) {
    return null;
  }

  return (
    <Form.Item style={{ marginBottom: 16 }}>
      <Checkbox
        checked={conAcompanante}
        onChange={(e) => onConAcompananteChange && onConAcompananteChange(e.target.checked)}
        disabled={disabled}
      >
        <Space>
          <UserOutlined style={{ color: "#722ed1" }} />
          <span>Con Acompañante</span>
        </Space>
      </Checkbox>
    </Form.Item>
  );
};

TAIFields.propTypes = {
  tipoTraslado: PropTypes.string,
  conAcompanante: PropTypes.bool,
  onConAcompananteChange: PropTypes.func,
  disabled: PropTypes.bool,
  tieneIntermunicipal: PropTypes.bool,
};

export default TAIFields;
